import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const EmojiHappyIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22Z"
		/>

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" d="M8.6 9.5V10" />

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" d="M15.4 9.5V10" />

		<path
			opacity={0.4}
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M8.4 14.5C9.3 15.7 10.6 16.3 12 16.3C13.4 16.3 14.7 15.7 15.6 14.5"
		/>
	</SvgIcon>
)

export default EmojiHappyIconAtom
